import React from 'react'

const Hamburger = (props) =>(
	<svg id="Hamburger-menu" xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21">
	  <rect id="Rectangle_2612" data-name="Rectangle 2612" width="24" height="3" fill="#fff"/>
	  <rect id="Rectangle_2613" data-name="Rectangle 2613" width="18" height="3" transform="translate(6 9)" fill="#fff"/>
	  <rect id="Rectangle_2614" data-name="Rectangle 2614" width="24" height="3" transform="translate(0 18)" fill="#fff"/>
	  <rect id="Rectangle_2636" data-name="Rectangle 2636" width="2" height="3" fill="#fab702"/>
	  <rect id="Rectangle_2637" data-name="Rectangle 2637" width="18" height="3" transform="translate(6 9)" fill={props.fill}/>
	  <rect id="Rectangle_2638" data-name="Rectangle 2638" width="24" height="3" transform="translate(0 18)" fill={props.fill}/>
	  <rect id="Rectangle_2639" data-name="Rectangle 2639" width="24" height="3" fill={props.fill}/>
	</svg>
)

export default Hamburger